import { array, boolean, nullable, number, object, string } from "superstruct";

export const MediaTagSchema = string();

export const MediaCollectionSchema = string();

export const MediaProductSchema = object({
    handle: string(),
    imageUrl: nullable(string()),
    productId: number(),
    title: string(),
    xCoordinate: number(),
    yCoordinate: number(),
    variantId: number(),
    price: number(),
    didViewerReact: nullable(boolean()),
    reactionsCount: nullable(number()),
});

export const MediaSchema = object({
    mediaId: string(),
    shopId: number(),
    src: string(),
    published: boolean(),
    tags: array(MediaTagSchema),
    products: array(MediaProductSchema),
    collections: array(MediaCollectionSchema),
    createdAt: string(),
    didViewerFave: nullable(boolean()),
    favesCount: nullable(number()),
});
